// Words cycle in sync with stripe panel colors
const TURAMY_WORDS = ['comfortable', 'safe', 'smart', 'affordable'];
const TURAMY_COLORS = ['#96D7EB', '#B1E1E9', '#839CB5', '#F2E4F9'];

document.addEventListener('DOMContentLoaded', () => {
  // ── Hero word animation ──────────────────────────────────────────────────
  document.querySelectorAll('.hero-wrapper em').forEach(em => {
    let current = 0;

    em.style.fontStyle = 'normal';
    em.style.display = 'inline-block';
    em.style.transition = 'opacity 0.3s ease, transform 0.3s ease, color 0.3s ease';
    em.style.color = TURAMY_COLORS[0];

    setInterval(() => {
      em.style.opacity = '0';
      em.style.transform = 'translateY(-8px)';

      setTimeout(() => {
        current = (current + 1) % TURAMY_WORDS.length;
        em.textContent = TURAMY_WORDS[current];
        em.style.color = TURAMY_COLORS[current];
        em.style.transform = 'translateY(8px)';

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            em.style.opacity = '1';
            em.style.transform = 'translateY(0)';
          });
        });
      }, 300);
    }, 2500);
  });

  // ── Scroll-triggered fade-in (mission + pillars stagger) ─────────────────
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    document.querySelectorAll('.turamy-fade-in, .turamy-stagger').forEach(el => {
      io.observe(el);
    });
  } else {
    // Fallback: show all immediately if IO not supported
    document.querySelectorAll('.turamy-fade-in, .turamy-stagger').forEach(el => {
      el.classList.add('is-visible');
    });
  }
});
